import React from "react";
import styles from "./Rating.module.scss";

function Rating({ rating }) {
  let starsRating = Math.floor(rating) * 2;

  // If rating has floating point number E.g. 3.2 , 3.7 add a half star
  if (rating % 1) {
    starsRating += 1;
  }
  return (
    <fieldset className={styles.rating}>
      {[...Array(10)].map((_, i) => {
        return (
          <HalfStar
            key={`halfstar-${i}`}
            type={i % 2 ? "half" : "full"}
            isChecked={i === 10 - starsRating}
          />
        );
      })}
    </fieldset>
  );
}

function HalfStar({ type, isChecked }) {
  return (
    <>
      <input disabled type="radio" checked={isChecked} />
      <label className={styles[type]} />
    </>
  );
}
export default Rating;
